<template>
  <div class="widget--popup" :class="[transition_class]" v-if="is_show">
    <div class="inner-wrap">
      <div class="popup-title" v-if="title">{{ title }}</div>
      <div class="popup-content">
        <slot></slot>
        <div class="close-btn" @click="close" v-if="closeable">
          <fa :icon="['fas','times']" size="3x"/>
        </div>
      </div>
    </div>
    <div class="overlay" @click="close"></div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    closeable: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  methods: {
    hideScrollbar(hide) {
      if(hide) {
        var width = document.body.offsetWidth;
        document.documentElement.style.overflowY = "hidden";
        var scrollWidth = document.body.offsetWidth - width;
        document.documentElement.style.marginRight = `${scrollWidth}px`;
      }else {
        document.documentElement.style.overflowY = "auto";
        document.documentElement.style.marginRight = "0px";
      }
    },
    show() {
      this.is_show = true;
      setTimeout(()=>{
        this.transition_class = "show";
      }, 100);

      console.log("show method");
      this.hideScrollbar(true);

    },
    close() {
      if(this.closeable) {
        this.force_close();
      }
    },
    force_close() {
      this.transition_class = "is_closing";
      setTimeout(()=>{
        console.log("close");
        this.$emit("close");
        this.is_show = false;
        this.hideScrollbar(false);
      }, 200);
    }
  },
  beforeDestroy() {
    this.is_show = false;
    this.hideScrollbar(false);
    console.log("before destroy");
  },
  data() {
    return {
      is_show: false,
      transition_class: ""
    }
  }
}
</script>

<style lang="scss">
.widget--popup{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1010;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  opacity: 0;
  transition: opacity .2s linear;
  & > .inner-wrap{
    max-width: 90%;
    max-height: 95%;
    z-index: 1011;
    position: relative;
    display: flex;
    flex-direction: column;
    .popup-title{
      background: black;
      width: 100%;
      color: white;
      padding: 10px 20px;
      font-size: large;
    }
    .popup-content{
      // height: 100%;
      flex-grow: 1;
      width: 100%;
      display: flex;
      justify-content: center;
      // align-items: center;
      .close-btn{
        color: white;
        position: absolute;
        top: -30px;
        right: -15px;
        filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.7))
      }
    }
  }
  .overlay{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, .2);
  }

  &.show{
    opacity: 1;
  }

  &.is_closing{
    opacity: 0;
  }
}
</style>
